var map = {
	"./Messages.jpg": 320,
	"./Messages.png": 123,
	"./book.png": 124,
	"./box.png": 125,
	"./chat.png": 126,
	"./chat_01.png": 321,
	"./chat_02.png": 322,
	"./chat_icon.png": 323,
	"./cloud.png": 127,
	"./dashboard.png": 324,
	"./dot.png": 325,
	"./get_started_bg.png": 326,
	"./john.png": 128,
	"./left_leaf.png": 129,
	"./live_chat.png": 130,
	"./mobile.png": 131,
	"./panguin_img_one.png": 132,
	"./panguin_img_three.png": 133,
	"./panguin_img_two.png": 134,
	"./pluse.png": 135,
	"./richard.png": 136,
	"./right_leaf.png": 137,
	"./skyp_1.png": 327,
	"./skyp_2.png": 328,
	"./support_dashboard.jpg": 329,
	"./triangle.png": 138,
	"./video_icon.png": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;